/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Yakov Gushchin
 * @author Maxim Fedorov
 * @version 1.11.0
 * @since 1.0.0
 */

import {
    INIT_APP_FAIL,
    INIT_APP_START,
    INIT_APP_SUCCESS,
    LOAD_APP_CONFIG_FAILURE,
    LOAD_APP_CONFIG_SUCCESS,
    SET_APP_ERROR,
    SET_APP_ERROR_CODE,
    SET_INIT_APP_ERROR,
} from './appConstants';
import {
    IAppConfig,
    ISetAppErrorPayload,
    ISetInitAppErrorPayload,
    TInitAppFail,
    TInitAppStart,
    TInitAppSuccess,
    TLoadAppConfigFailure,
    TLoadAppConfigSuccess,
    TSetAppErrorAction,
    TSetAppErrorCodeAction,
    TSetInitAppErrorAction,
} from './appTypes';
import { createAction } from './createAction';

/**
 * Start main event for initializing store
 * @returns {TInitAppStart}
 */

export const initAppStart = (): TInitAppStart => createAction(INIT_APP_START);

/**
 * Success main event for initializing store
 * @returns {TInitAppSuccess}
 */

export const initAppSuccess = (): TInitAppSuccess => createAction(INIT_APP_SUCCESS);

/**
 * Fail main event for initializing store
 * @returns {TInitAppFail}
 */

export const initAppFail = (payload: string): TInitAppFail => createAction(INIT_APP_FAIL, payload);

export const loadAppConfigSuccess = (payload: IAppConfig): TLoadAppConfigSuccess =>
    createAction(LOAD_APP_CONFIG_SUCCESS, payload);

export const loadAppConfigFailure = (payload: string): TLoadAppConfigFailure =>
    createAction(LOAD_APP_CONFIG_FAILURE, payload);

/*
* -------------------------------------------
*           APP ERROR
* -------------------------------------------
*/

export const setAppError = (payload: ISetAppErrorPayload): TSetAppErrorAction =>
    createAction(SET_APP_ERROR, payload);

export const setInitAppError = (payload: ISetInitAppErrorPayload): TSetInitAppErrorAction =>
    createAction(SET_INIT_APP_ERROR, payload);

export const setAppErrorCode = (code: string): TSetAppErrorCodeAction =>
    createAction(SET_APP_ERROR_CODE, { code });


export type IAppActionTypes =
    TInitAppStart
    | TInitAppFail
    | TInitAppSuccess
    | TLoadAppConfigFailure
    | TLoadAppConfigSuccess
    | TSetAppErrorAction
    | TSetAppErrorCodeAction
    | TSetInitAppErrorAction
    ;
